import React from 'react';
import styles from './SocialIcons.module.css';
import { FaFacebookF, FaInstagram, /* FaPinterestP, */ FaLinkedinIn /* , FaTiktok, FaYoutube */ } from 'react-icons/fa';

interface SocialIconsProps {
  fontSize?: string;
  iconColor?: string;
  hoverColor?: string;
}

const SocialIcons: React.FC<SocialIconsProps> = ({ fontSize, iconColor, hoverColor }) => {
  const containerStyle = fontSize ? { fontSize } : undefined;

  const getLinkStyle = (isHovered: boolean) => {
    const baseStyle: React.CSSProperties = {};
    if (iconColor && !isHovered) {
      baseStyle.color = iconColor;
    }
    if (hoverColor && isHovered) {
      baseStyle.color = hoverColor;
    }
    return baseStyle;
  };

  const [hoveredLink, setHoveredLink] = React.useState<string | null>(null);

  return (
    <div className={styles.socialIcons} style={containerStyle}>
      <a
        href="https://www.facebook.com/LBtilingco"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        style={getLinkStyle(hoveredLink === 'facebook')}
        onMouseEnter={() => setHoveredLink('facebook')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        <FaFacebookF />
      </a>
      <a
        href="https://www.linkedin.com/company/lb-tiling-company/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn"
        style={getLinkStyle(hoveredLink === 'linkedin')}
        onMouseEnter={() => setHoveredLink('linkedin')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        <FaLinkedinIn />
      </a>
      <a
        href="https://www.instagram.com/lb_tiling.co/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        style={getLinkStyle(hoveredLink === 'instagram')}
        onMouseEnter={() => setHoveredLink('instagram')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        <FaInstagram />
      </a>
      {/* <a
        href="https://www.youtube.com/@lbtiling"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="YouTube"
        style={getLinkStyle(hoveredLink === 'youtube')}
        onMouseEnter={() => setHoveredLink('youtube')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        <FaYoutube />
      </a> */}
      {/* <a
        href="https://www.pinterest.ca/lbtiling/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Pinterest"
        style={getLinkStyle(hoveredLink === 'pinterest')}
        onMouseEnter={() => setHoveredLink('pinterest')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        <FaPinterestP />
      </a> */}
      {/* <a
        href="https://www.tiktok.com/@lbtiling"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
        style={getLinkStyle(hoveredLink === 'tiktok')}
        onMouseEnter={() => setHoveredLink('tiktok')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        <FaTiktok />
      </a> */}
    </div>
  );
};

export default SocialIcons;
